import React from 'react';
import styles from './OrgsFilterToggle.module.scss';
import { Icon, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  applyOrgsFilter,
  resetFilter,
} from '../../store/actions/documentFilterNew.actions';
import { setChosenDocumentsFilter } from '../../store/actions/documentFilter/documentFilterActions';

const OrgsFilterToggle = ({ org, record }) => {
  const { orgsIds } = useSelector((state) => state.documentFilterNewStore);

  const dispatch = useDispatch();

  const isActive = !!orgsIds?.length;

  const handleOrgsFilter = () => {
    if (!!record?.seviceCompanyId && !!org?.orgId) {
      dispatch(
        applyOrgsFilter({
          companyId: record?.seviceCompanyId,
          orgsIds: [org?.orgId],
        })
      );

      dispatch(setChosenDocumentsFilter({ name: org?.orgName }));
    }
  };

  const handleClick = (e) => {
    e.stopPropagation();

    if (isActive) {
      dispatch(resetFilter());
      return;
    }

    handleOrgsFilter();
  };

  return (
    <Tooltip
      title={
        isActive
          ? 'Отменить фильтр по организации'
          : 'Применить фильтр по организации'
      }
    >
      <Icon
        onClick={handleClick}
        type="filter"
        className={styles.icon}
      />
    </Tooltip>
  );
};

export default OrgsFilterToggle;
